import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const Map = ({ markerPosition, setMarkerPosition, arrayMarkers }) => {
  return (
    <GoogleMap
      defaultZoom={10}
      center={markerPosition || { lat: 19.949784, lng: -102.285742 }}
      onClick={(e) => {
        setMarkerPosition({
          lat: e.latLng.lat(),
          lng: e.latLng.lng(),
        });
      }}
    >
      {/* Mostrar el marcador si existe */}
      {markerPosition && <Marker position={markerPosition} />}

      {/* Renderizar marcadores adicionales del array */}
      {/* {arrayMarkers &&
        arrayMarkers.map((el, i) => (
          <Marker
            key={i}
            position={{
              lat: parseFloat(el.latitude),
              lng: parseFloat(el.longitude),
            }}
          />
        ))} */}
    </GoogleMap>
  );
};

export default withScriptjs(withGoogleMap(Map));
